export enum ApplicationVariant {
    DEFAULT,
    CREDIT
}
export enum ApplicationVariant {
    DEFAULT,
    CREDIT
}
